import apiClient from './apiClient';

const pagamentiService = {
  getMyDocuments: async () => {
    const response = await apiClient.get('/pagamenti.php');
    return response.data;
  },

  getCollaboratoreDocuments: async (collaboratoreId) => {
    const response = await apiClient.get(`/pagamenti.php?collaboratore_id=${collaboratoreId}`);
    return response.data;
  },

  uploadDocuments: async (files, collaboratoreId, tipo, mese, anno) => {
    const formData = new FormData();
    files.forEach((file) => formData.append('files[]', file));
    formData.append('collaboratore_id', collaboratoreId);
    formData.append('tipo', tipo);
    if (mese) formData.append('mese', mese);
    if (anno) formData.append('anno', anno);
    const response = await apiClient.post('/pagamenti.php?action=upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  markAsRead: async (documentoId) => {
    const response = await apiClient.post('/pagamenti.php?action=mark_read', {
      documento_id: documentoId,
    });
    return response.data;
  },

  deleteDocument: async (documentoId) => {
    const response = await apiClient.delete(`/pagamenti.php?id=${documentoId}`);
    return response.data;
  },
};

export default pagamentiService;
